
import React from "react";
import {
  Box,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Heading,
  HStack,
  VStack,
  Text,
  Badge,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Progress
} from "@chakra-ui/react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";

/************************************  DATA QUALITY HEALTH  ************************************/
export const DataQualityHealth = () => {
  const metrics = [
    { label: "Email Validity", value: 94 },
    { label: "Phone Validity", value: 88 },
    { label: "Duplicate Users", value: 2, inverse: true },
  ];

  const bg     = useColorModeValue("white", "gray.800");
  const border = useColorModeValue("gray.100", "gray.700");

  return (
    <Box p={6} bg={bg} rounded="xl" border="1px" borderColor={border} shadow="sm">
      <Heading as="h3" size="md" mb={4}>Data Quality Health</Heading>
      <VStack align="stretch" spacing={3}>
        {metrics.map((metric) => (
          <Box key={metric.label}>
            <HStack justify="space-between" mb={1}>
              <Text fontSize="sm">{metric.label}</Text>
              <Text fontSize="sm" fontWeight="medium">
                {metric.inverse ? `${metric.value}% duplicates` : `${metric.value}%`}
              </Text>
            </HStack>
            {!metric.inverse && (
              <Progress
                value={metric.value}
                size="sm"
                colorScheme={metric.value > 90 ? "green" : metric.value > 70 ? "yellow" : "red"}
                rounded="md"
              />
            )}
          </Box>
        ))}
      </VStack>
    </Box>
  );
};
